<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="pro_div">
			<div class="row">
				<div class="col">
					<span style="margin-bottom: 30px;">审批流程图：</span>
					<div class="left_div">
						<span class="item_div">创建申请</span>
						<div class="item_pro">
							<span class="span_icon">|</span>
							<i class="el-icon-circle-plus" @click="addItem(0)"></i>
							<i class="el-icon-bottom"></i>
						</div>
						<div v-if="proList.length > 0" class="left_div" v-for="(item,index) in proList" :key="index">
							<div class="left_item_div" @click="editItem(index)">
								<div class="type_div">
									<span>{{item.node_name}}</span>
									<i class="el-icon-delete" @click.stop="deleteItem(index)"></i>
								</div>
								<span class="name_div">{{item.admin_name}}</span>
							</div>
							<div class="item_pro">
								<span class="span_icon">|</span>
								<i class="el-icon-circle-plus" @click="addItem(index+1)"></i>
								<i class="el-icon-bottom"></i>
							</div>
						</div>
						<span class="item_div">流程结束</span>
					</div>
				</div>
				<div v-if="selectIndex != -1" class="right">
					<span>流程节点设置：</span>
					<div class="right_div">
						<span style="width: 100px;">审批名称：</span>
						<el-input placeholder="请填写审批名称" v-model="proList[selectIndex].node_name" clearable/>
					</div>
					<div class="right_div">
						<span style="width: 75px;">选审核人：</span>
						<el-select v-model="proList[selectIndex].node_admin_id" clearable
							placeholder="请选择审批人" @change="selectChange">
							<el-option v-for="item in roleList" :key="item.admin_id" :label="item.nick_name"
								:value="item.admin_id" />
						</el-select>
					</div>
					<div class="right_div">
						<span style="color: #00A292;">当前审核人拒绝本次申请时，记录退回上一审核人。</span>
					</div>
				</div>
			</div>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="confirm">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		oaFlow,
		adminLists
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				tip: '审批内容项的自定义编辑',
				roleList: [], //管理员列表(角色列表)
				proList: [],
				selectIndex: -1,
				page: 1,
				limit: 10
			}
		},
		mounted() {
			this.getRoleList();
			
		},
		methods: {
			
			//获取角色列表
			getRoleList() {
				adminLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.total = res.count;
						this.roleList = res.data;
						this.getOaFlowDetail();
					}
				}).catch(err => {})
			},

			//获取审批流程详情
			getOaFlowDetail() {
				oaFlow({
					template_id: this.type
				}, 0).then(res => {
					if (res.code == 0) {
						if(res.data.length > 0){
							var obj = {}
							res.data.forEach((item,index)=>{
								obj = {
									node_name: item.node_name,
									node_admin_id: item.admin.admin_id,
									admin_name: item.admin ? item.admin.nick_name : ''
								}
								this.proList.push(obj)
							})
						}
					}
				}).catch(err => {})
			},
			
			//下拉选择器
			selectChange(val){
				var index = this.roleList.findIndex(item => item.admin_id === val);
				this.proList[this.selectIndex].admin_name = this.roleList[index].nick_name
			},

			//确认
			confirm() {
				oaFlow({
					template_id: this.type,
					nodes:this.proList
				}, 1).then(res => {
					if (res.code == 0) {
						this.$emit('close',0)
						this.$message.success(res.msg);
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			//添加节点
			addItem(index) {
				var obj = {
					node_name: '审批名称',
					node_admin_id: '',
					admin_name:'审批人'
				}
				this.proList.splice(index, 0, obj)
			},

			//移除节点
			deleteItem(index) {
				this.proList.splice(index, 1)
				this.selectIndex = -1;
			},

			//编辑节点信息
			editItem(index) {
				this.selectIndex = index;
			},

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.pro_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 590px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.left_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 300px;
	}

	.item_div {
		width: 200px;
		text-align: center;
		font-size: 14px;
		color: #767676;
		padding: 15px 0;
		border: 1px solid #767676;
		border-radius: 5px;
		margin: 10px 0;
	}

	.left_item_div {
		width: 200px;
		display: flex;
		flex-direction: column;
		text-align: center;
		border: 1px solid #0256FF;
		border-radius: 5px;
		margin: 10px 0
	}

	.type_div {
		width: 100%;
		height: 26px;
		padding: 5px 0;
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		background: rgba(2, 86, 255, 0.2);
		font-size: 14px;
		color: #000;
	}

	.el-icon-delete {
		position: absolute;
		right: 10px;
		font-size: 20px;
		color: #EA0000;
	}

	.name_div {
		height: 26px;
		font-size: 14px;
		color: #000;
		padding: 10px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.item_pro {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.span_icon {
		display: flex;
		justify-content: center;
		font-size: 15px;
		color: #767676;
	}

	.el-icon-circle-plus {
		font-size: 20px;
		margin: 5px 0 2px 0;
		color: #00A292
	}

	.el-icon-bottom {
		font-size: 20px;
		color: #767676;
	}

	.right {
		display: flex;
		flex-direction: column;
		position: fixed;
		left: 550px;
	}

	.right_div {
		display: flex;
		flex-direction: row;
		margin: 30px 0 0 30px;
		font-size: 14px;
		color: #000;
		align-items: center;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>